module.exports = __webpack_public_path__ + "static/media/VHST03.0a2011e4.jpg";